'use strict';
import {homeTop} from './blocks/home_top';
import {homeSlider} from './blocks/home_slider';
import {homeRefs} from './blocks/home_refs';
import {homeVideo} from './blocks/home_video';
import {prlxBlocks} from './blocks/block_prlx';
import {swipers} from './blocks/block_gallery';
import {techsList} from './blocks/techs_list';
import {blockSite} from './blocks/block_site';
import {footer} from './blocks/footer';
// import {nextProject} from './blocks/next_project';
// import {blockFeedback} from './blocks/block_feedback';
import {changeH2ToH3} from './blocks/services_pages';
// import {mapFunc} from './blocks/block_map';

export const allBlocksInit = () => {
  homeTop.init();
  // homeSlider.init();
  homeVideo.init();
  homeRefs.init();
  prlxBlocks.init();
  // swipers.init();
  techsList.init();
  blockSite.init();
  footer.init();
  // nextProject.init();
  // blockFeedback.init();

  changeH2ToH3();
  // mapFunc();
};
